import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Head from '../../../components/Partials/Head/Head';
import Auxiliary from '../../../hoc/Auxiliary';
import ServiceBanner from '../../../components/ServiceBanner/ServiceBanner';
import satelliteIcon from '../../../components/Satellites/satelliteIcon';
import satelliteLinks from '../../../components/Satellites/satelliteLinks';
import CostNoItSupport2 from '../../../components/Satellites/itSupport/CostNoItSupport/CostNoItSupport2/CostNoItSupport2';
import CostNoItSupport3 from '../../../components/Satellites/itSupport/CostNoItSupport/CostNoItSupport3/CostNoItSupport3';
import CostNoItSupport4 from '../../../components/Satellites/itSupport/CostNoItSupport/CostNoItSupport4/CostNoItSupport4';
import CostNoItSupport5 from '../../../components/Satellites/itSupport/CostNoItSupport/CostNoItSupport5/CostNoItSupport5';
import CostNoItSupport6 from '../../../components/Satellites/itSupport/CostNoItSupport/CostNoItSupport6/CostNoItSupport6';

class CostNoItSupport extends Component {
  render() {
    return (
      <Auxiliary>
        <Head {...this.props} id="cost_no_it_support" />
        <ServiceBanner {...this.props} page="costNoItSupport" icon={satelliteIcon} textComponents={satelliteLinks(this.props.t)} />
        <CostNoItSupport2 {...this.props} />
        <CostNoItSupport3 {...this.props} />
        <CostNoItSupport4 {...this.props} />
        <CostNoItSupport5 {...this.props} />
        <CostNoItSupport6 {...this.props} />
      </Auxiliary>
    )
  }
}
export default withTranslation()(CostNoItSupport);
